import { CuttingShapeOverlayService } from '@/infrastructure/engine2d/overlays/CuttingShapeOverlayService';
import { paintCuttingShape, paintMirroredCuttingShape } from '@/infrastructure/engine2d/cuttingShape/paintCuttingShape';
import type { CuttingShape } from '@/domain/cuttingShape/CuttingShape';
import type { FabricScene } from '@/infrastructure/engine2d/FabricScene';
import type { ICuttingShapeEngine, TPaintCuttingShapeOptions } from '@/application/ports/ICuttingShapeEngine';

class FabricCuttingShapeEngine implements ICuttingShapeEngine {
    private readonly _cuttingShapeOverlay: CuttingShapeOverlayService;

    constructor(private readonly _scene: FabricScene) {
        this._cuttingShapeOverlay = new CuttingShapeOverlayService({ canvas: _scene.fabricCanvas });
    }

    clear(): void {
        this._cuttingShapeOverlay.remove();
    }

    paint(shape: CuttingShape, options: TPaintCuttingShapeOptions = {}): Promise<void> {
        const maskOutsideCut = options.maskOutsideCut ?? true;
        if (options.mirrored) {
            return paintMirroredCuttingShape(shape.url, this._scene, maskOutsideCut);
        }
        return paintCuttingShape(shape.url, this._scene, maskOutsideCut) ?? Promise.resolve();
    }
}

export { FabricCuttingShapeEngine };
